import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Apply theme synchronously before any rendering to prevent flash (fastest possible)
(function applyThemeFast() {
  if (typeof window === 'undefined') return;
  
  // Force dark theme regardless of any previously saved value
  const storedTheme = window.localStorage.getItem('ai-theme');
  const savedTheme = 'dark';
  if (storedTheme !== 'dark') {
    window.localStorage.setItem('ai-theme', 'dark');
  }
  const isDark = savedTheme === 'dark';
  
  // Apply theme classes directly (fastest method)
  const body = document.body;
  if (isDark) {
    body.className = body.className.replace(/theme-\w+/g, '') + ' theme-dark';
    document.documentElement.style.colorScheme = 'dark';
  } else {
    body.className = body.className.replace(/theme-\w+/g, '') + ' theme-light';
    document.documentElement.style.colorScheme = 'light';
  }
  document.documentElement.setAttribute('data-theme', savedTheme);
})();

// Register Service Worker for PWA (skip in development)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(() => {
        // Service worker registered successfully
      })
      .catch(() => {
        // Service worker registration failed
      });
  });
} else if ('serviceWorker' in navigator && process.env.NODE_ENV === 'development') {
  // Unregister service worker in development to avoid conflicts
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
